import React, { useState } from "react";
import { supportSubpanel, supportSubpanelHeader } from "./supportStyles";

const ActionSubpanel = ({ id, title, summary, defaultOpen = false, contentClassName = "p-3", children }) => {
  const [open, setOpen] = useState(defaultOpen);
  const [opened, setOpened] = useState(defaultOpen);

  return (
    <section className={supportSubpanel} aria-labelledby={id}>
      <h4 id={id} className="m-0">
        <button
          type="button"
          onClick={() => {
            setOpen((value) => !value);
            setOpened(true);
          }}
          aria-expanded={open}
          aria-controls={`${id}-body`}
          className={`${supportSubpanelHeader} w-full flex items-center gap-2 text-left hover:bg-slate-100 transition-colors`}
        >
          <span className="text-gray-500 text-xs w-3 text-center shrink-0" aria-hidden>
            {open ? "▼" : "▶"}
          </span>
          <span className="text-xs font-semibold uppercase tracking-wide text-gray-700 shrink-0">
            {title}
          </span>
          {!open && summary && (
            <span className="text-xs font-normal normal-case tracking-normal text-gray-500 truncate min-w-0">
              {summary}
            </span>
          )}
        </button>
      </h4>
      <div id={`${id}-body`} hidden={!open}>
        {opened && <div className={contentClassName}>{children}</div>}
      </div>
    </section>
  );
};

export default ActionSubpanel;
